export default __webpack_public_path__ + "static/codeigniter_service_features-6170e3b7c794f0bc3ffc0fbb97062f08.svg";